import React, { Component } from 'react';
import { connect } from 'react-redux';
//utils
import { Translations } from '../../../../utils';
// children
import { PoolList, StandaloneList } from './GlsNotionalPoolingStrucutre/'
// import  AddPool  from './GlsNotionalPoolingStrucutre/AddPool/'
// import  AddStandalone  from './GlsNotionalPoolingStrucutre/AddStandalone/'

class GlsNotionalPoolingStrucutre extends Component {

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {

    const { pageJson1 } = this.props;

    const editPoolEvent = (event, id = null) => {
      let CaseId = this.props.match.params.caseId || '';
      let productId = this.props.match.params.productId || '';
      if (CaseId && productId) {
        this.props.history.push({
          pathname: `/case-body/capture-product-notional-pooling/add-pool/${CaseId}/${productId}/`,
          state: {
            statuses: this.props.statuses,
            currency: this.props.currency,
            id: id,
            mode: 'edit',
            productId: productId,
            isNavigate: this.props.isNavigate
          }
        });
      } else {
        alert("something went wrong")
      }

    }

    const addPoolEvent = (event, id = null) => {
      let CaseId = this.props.match.params.caseId || '';
      let productId = this.props.match.params.productId || '';
      if (CaseId && productId) {
        this.props.history.push({
          pathname: `/case-body/capture-product-notional-pooling/add-pool/${CaseId}/${productId}/`,
          state: {
            statuses: this.props.statuses,
            currency: this.props.currency,
            id: id,
            mode: 'add',
            productId: productId,
            isNavigate: this.props.isNavigate
          }
        });
      } else {
        alert("something went wrong")
      }
    }

    const editStandaloneEvent = (event, id = null) => {
      let CaseId = this.props.match.params.caseId || '';
      let productId = this.props.match.params.productId || '';
      if (CaseId && productId) {
        this.props.history.push({
          pathname: `/case-body/capture-product-notional-pooling/add-standalone/${CaseId}/${productId}/`,
          state: {
            statuses: this.props.statuses,
            currency: this.props.currency,
            id: id,
            mode: 'edit'
          }
        });
      } else {
        alert("something went wrong")
      }
    }

    const addStandaloneEvent = (event, id = null) => {
      let CaseId = this.props.match.params.caseId || '';
      let productId = this.props.match.params.productId || '';
      if (CaseId && productId) {
        this.props.history.push({
          pathname: `/case-body/capture-product-notional-pooling/add-standalone/${CaseId}/${productId}/`,
          state: {
            statuses: this.props.statuses,
            currency: this.props.currency,
            id: id,
            mode: 'add'
          }
        });
      } else {
        alert("something went wrong")
      }
    }

    return (
      <div>
        <div className="gdocs-banner msgblue">
          <div>
            <i className="icon icon-circle-error-solid msgblue"></i>
            <span>{this.translations(pageJson1.notificationText)}</span>
          </div>
          {pageJson1.notificationText2 ? <div>
            <i className="icon icon-circle-error-solid msgblue"></i>
            <span>{this.translations(pageJson1.notificationText2)}</span>
          </div> : null}
        </div>
        <PoolList
          {...this.props}
          editPoolEvent={editPoolEvent}
          lang={this.props.lang}
        />
        <StandaloneList
          {...this.props}
          editStandaloneEvent={editStandaloneEvent}
          lang={this.props.lang}
        />
        <div className="form-buttons-wrapper">
          <button disabled={this.props.customer.roleDetails.customer} aria-label={this.translations(pageJson1.addPoolBtnText)} onClick={addPoolEvent}>{this.translations(pageJson1.addPoolBtnText)}</button>
          <button disabled={this.props.customer.roleDetails.customer} aria-label={this.translations(pageJson1.addStandaloneAccBtnText)} onClick={addStandaloneEvent}> {this.translations(pageJson1.addStandaloneAccBtnText)}</button>
        </div>
      </div>
    );
  }

}

const mapStateToProps = state => ({
  lang: state.lang,
  customer: state.auth.userDetails
})

export default connect(mapStateToProps, null)(GlsNotionalPoolingStrucutre);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/GlsNotionalPoolingStrucutre.js